// extracted by mini-css-extract-plugin
export default {"item":"SidebarItem_item__ZZVUI","link":"SidebarItem_link__1fulN","icon":"SidebarItem_icon__aM3-t careerIcon_careerIconSmallest__CYMgi careerIcon_careerIcon__Oh64b"};